'use strict';
import * as $j_app$002edata$002e$002dOrganization$002dAddress$0024package$0024$002dOrganization$002dAddress$0024 from "./app.data.-Organization-Address$package$-Organization-Address$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$() {
  this.aCw = null;
  this.aCN = null;
  this.aCz = null;
  this.aCA = false;
  this.aCF = null;
  this.aCG = false;
  this.aCL = null;
  this.aCM = false;
  this.aCx = null;
  this.aCy = false;
  this.aCJ = null;
  this.aCK = false;
  this.aCH = null;
  this.aCI = false;
  this.aCB = null;
  this.aCC = false;
  this.aCD = null;
  this.aCE = false;
  $n_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ = this;
  this.aCw = $j_app$002edata$002e$002dOrganization$002dAddress$0024package$0024$002dOrganization$002dAddress$0024.$m_Lapp_data_OrganizationAddress$package$OrganizationAddress$();
  this.aCN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dOrganization$002dAddress$0024package$0024$002dOrganization$002dAddress$0024.$m_Lapp_data_OrganizationAddress$package$OrganizationAddress$());
}
export { $c_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ as $c_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ };
$p = $c_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$;
/** @constructor */
function $h_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$() {
}
export { $h_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ as $h_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ };
$h_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$.prototype = $p;
$p.eR = (function() {
  return this.aCw;
});
$p.eO = (function() {
  return this.aCN;
});
$p.bW = (function() {
  if ((!this.aCA)) {
    this.aCz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aCA = true;
  }
  return this.aCz;
});
$p.b9 = (function() {
  if ((!this.aCG)) {
    this.aCF = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aCG = true;
  }
  return this.aCF;
});
$p.b3 = (function() {
  if ((!this.aCM)) {
    this.aCL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aCM = true;
  }
  return this.aCL;
});
$p.aG = (function() {
  if ((!this.aCy)) {
    this.aCx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aCy = true;
  }
  return this.aCx;
});
$p.az = (function() {
  if ((!this.aCK)) {
    this.aCJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aCK = true;
  }
  return this.aCJ;
});
$p.aY = (function() {
  if ((!this.aCI)) {
    this.aCH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aCI = true;
  }
  return this.aCH;
});
$p.Jh = (function() {
  if ((!this.aCC)) {
    this.aCB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Address";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aCC = true;
  }
  return this.aCB;
});
$p.bNB = (function() {
  if ((!this.aCE)) {
    this.aCD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().zt;
    this.aCE = true;
  }
  return this.aCD;
});
var $d_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$, "app.data.OrganizationAddress$package$OrganizationAddressForm$", ({
  Ef: 1,
  N: 1
}));
export { $d_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ as $d_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ };
var $n_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$;
function $m_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$() {
  if ((!$n_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$)) {
    $n_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ = new $c_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$();
  }
  return $n_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$;
}
export { $m_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ as $m_Lapp_data_OrganizationAddress$package$OrganizationAddressForm$ };
//# sourceMappingURL=app.data.-Organization-Address$package$-Organization-Address-Form$.js.map
